import { render, staticRenderFns } from "./CommonTextComponent.vue?vue&type=template&id=12da6a98&"
import script from "./CommonTextComponent.vue?vue&type=script&lang=js&"
export * from "./CommonTextComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports